import { ReactElement, useState } from 'react';
import { TreeSelect, TreeSelectProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FilterButton } from 'common/components/ExtendedTable/components/FilterButton/FilterButton';
import { TCounterpartiesListResData } from 'domains/counterparties/types/counterparty.types';
import { ERoleSearchParamsKey } from 'pages/user-role-management/roles/enums/roles.enum';
import { SFiltersContainer, STreeSelectContainer } from './BranchesCounterpartiesFilter.style';

export const BranchesCounterpartiesFilter = ({
  counterpartiesData,
  selectedCounterpartyGuid,
}: {
  counterpartiesData: TCounterpartiesListResData | {};
  selectedCounterpartyGuid: string;
}): ReactElement => {
  const navigate = useNavigate();

  const [showFilters, setShowFilters] = useState(false);

  const handleCounterpartyChange: TreeSelectProps['onChange'] = (value) => {
    const searchParams = new URLSearchParams();
    searchParams.append(ERoleSearchParamsKey.CounterpartyGuid, value);
    navigate({
      search: searchParams.toString(),
    });
  };

  const treeData = ((counterpartiesData as TCounterpartiesListResData)?.counterparties || []).map((counterparty) => ({
    label: counterparty.name,
    value: counterparty.guid,
  }));
  return (
    <SFiltersContainer>
      <FilterButton
        onClick={(): void => {
          setShowFilters((prev) => !prev);
        }}
        shown={showFilters}
      />

      {showFilters && (
        <STreeSelectContainer>
          <TreeSelect
            style={{
              width: '100%',
            }}
            value={selectedCounterpartyGuid}
            onChange={handleCounterpartyChange}
            treeData={treeData}
          />
        </STreeSelectContainer>
      )}
    </SFiltersContainer>
  );
};
